module.exports = __webpack_public_path__ + "img/article_consortia.79b68bae.jpg";